// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RewardMilestone from "../domain/types/RewardMilestone.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrModalsHelper from "./helpers/RnrModalsHelper.bs.js";
import * as UnorderedListComponent from "./UnorderedListComponent.bs.js";

var crossIcon = RnrAssetManager.getImage("cross_icon.svg");

function getTnc(award) {
  if (typeof award === "number" || award.TAG !== /* Coupon */8) {
    return null;
  } else {
    return React.createElement(UnorderedListComponent.make, {
                list: award._0.coupon_scheme.terms_and_conditions
              });
  }
}

function closeButtonHandler(param) {
  window.history.back();
  
}

function RnrCouponTncComponent(Props) {
  var viewModel = Props.viewModel;
  var milestone = Props.milestone;
  var content = Props.content;
  return React.createElement("div", {
              className: "tnc-container-wrapper"
            }, React.createElement("div", {
                  className: "title-container"
                }, React.createElement("div", {
                      className: "icon-wrapper",
                      onClick: (function (_event) {
                          window.history.back();
                          
                        })
                    }, React.createElement("img", {
                          className: "cross-icon",
                          src: crossIcon
                        })), React.createElement("div", {
                      className: "title"
                    }, content.couponAward.tncText)), React.createElement("div", {
                  className: "tnc-wrapper"
                }, getTnc(RnrModalsHelper.getAward(viewModel.milestoneDetails, RewardMilestone.fromUrlString(milestone), false))));
}

var make = RnrCouponTncComponent;

export {
  crossIcon ,
  getTnc ,
  closeButtonHandler ,
  make ,
  
}
/* crossIcon Not a pure module */
